import { tutorialSteps } from "../../../mocks/guaData";

export default function Tutorial() {
  return (
    <section id="tutorial" className="w-full bg-background-50 py-14 md:py-20" aria-label="上手教程">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <span className="text-sm font-semibold uppercase tracking-wider text-primary-600">Tutorial</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              上手教程：从安装到玩转只需几步
            </h2>
            <p className="mt-3 text-base leading-relaxed text-foreground-600">
              别被一堆功能吓到，吃瓜神器的上手非常线性。跟着下面四步走，
              你很快就能从萌新变成熟练的吃瓜选手。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
          {tutorialSteps.map((s, idx) => (
            <article key={s.step} className="relative rounded-lg bg-background-100 p-6 ring-1 ring-background-200">
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-lg text-white">
                  <i className={s.icon} aria-hidden="true"></i>
                </span>
                <span className="font-heading text-3xl font-bold text-primary-200">{s.step}</span>
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
              {idx < tutorialSteps.length - 1 && (
                <i
                  className="ri-arrow-right-line absolute -right-3 top-1/2 hidden -translate-y-1/2 text-xl text-primary-300 lg:block"
                  aria-hidden="true"
                ></i>
              )}
            </article>
          ))}
        </div>

        <div className="mt-6 flex flex-col items-start gap-2 rounded-lg bg-secondary-100 p-5 ring-1 ring-secondary-200 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-start gap-2">
            <i className="ri-lightbulb-flash-line mt-0.5 text-lg text-secondary-700" aria-hidden="true"></i>
            <p className="text-sm leading-relaxed text-secondary-900">
              <strong>小贴士：</strong>初装时领域关注别勾太满，先挑 2~3 个高频领域，
              等熟悉节奏后再慢慢扩充，推送体验会更舒适。
            </p>
          </div>
          <a
            href="#guides"
            className="whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-secondary-600"
          >
            进阶玩法攻略
          </a>
        </div>
      </div>
    </section>
  );
}